import { render, staticRenderFns } from "./MgrupajeequipamientoFormHeader.vue?vue&type=template&id=5ebd835c"
import script from "./MgrupajeequipamientoFormHeader.vue?vue&type=script&lang=js"
export * from "./MgrupajeequipamientoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports